import { supabase } from "../lib/supabase";

export interface AuthError {
  message: string;
}

export const authService = {
  /**
   * Sign in with Google
   */
  async signInWithGoogle() {
    try {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
        },
      });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return {
        data: null,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "An error occurred during Google sign in",
        },
      };
    }
  },

  /**
   * Sign out the current user
   */
  async signOut() {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      return { error: null };
    } catch (error) {
      return {
        error: {
          message:
            error instanceof Error
              ? error.message
              : "An error occurred during sign out",
        },
      };
    }
  },

  /**
   * Get the current session
   */
  async getSession() {
    try {
      const {
        data: { session },
        error,
      } = await supabase.auth.getSession();
      if (error) throw error;
      return { session, error: null };
    } catch (error) {
      return {
        session: null,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "An error occurred while getting session",
        },
      };
    }
  },

  /**
   * Get the current user
   */
  async getUser() {
    try {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();
      if (error) throw error;
      return { user, error: null };
    } catch (error) {
      return {
        user: null,
        error: {
          message:
            error instanceof Error
              ? error.message
              : "An error occurred while getting user",
        },
      };
    }
  },
};

/**
 * Get the current user session (simplified helper)
 */
export async function getUserSession() {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();
  if (error) throw error;
  return session;
}
